// src/ai/index.ts — public interface for the AI module.
export { aiGenerate, AIError } from './client';
export { listPrompts, getPrompt, interpolate } from './prompts';
import { aiGenerate } from './client';
import { getPrompt, interpolate } from './prompts';
/**
 * High-level helper: run a named prompt with variable substitutions.
 * This is the 90% API — most callers use this, not aiGenerate() directly.
 */
export async function runPrompt(promptId, vars, opts = {}) {
    const p = getPrompt(promptId);
    return aiGenerate({
        prompt_id: p.id,
        org_id: opts.org_id,
        system: interpolate(p.system, vars),
        messages: [{ role: 'user', content: interpolate(p.user_template, vars) }],
        model: opts.model ?? p.model,
        max_tokens: p.max_tokens,
        temperature: p.temperature,
    });
}
